import React from 'react';
import Logo from '../../../assets/ParroticaLogo.svg';
import SignLogo from '../../../assets/sign_up.png';
import propTypes from 'prop-types';
import './AuthLayout.css';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

const AuthLayout = ({ layoutImage }) => {
   return (
      <Box 
        sx={{
         minHeight: '100vh',
         display: 'flex',
         alignItems: 'center',
         justifyContent: 'center',
         backgroundImage: `url(${SignLogo})`,
         backgroundSize: 'cover',
         backgroundPosition: 'center',
         backgroundRepeat: 'no-repeat',
         padding: { xs: 1, sm: 3, md: 4 },
       }}
      
      height="fit" display="flex"  className="authLayout">
      
     
       
          
            <Box
               className="formWrapper"
               sx={{
                  width: {
                     xs: '100%',    
                     sm: '80%',     
                     md: '60%',     
                     lg: '40%',   
                     xl: '25%',  
                   },
                  marginX: 'auto',
                  paddingX: '25px',
                  height: 'fit',
                  paddingBottom:'20px',
                  backgroundColor: 'white',
                  borderRadius: 1,
               }}
            >
               <Outlet />
            </Box>
        
      </Box>
   );
};

AuthLayout.propTypes = {
   layoutImage: propTypes.any,
};

export default AuthLayout;
